import React, { useEffect, useState } from "react";
import { api_Routes } from "../../tools/api_Routes";
import { Helper } from "../../tools/Helper";
import Setting from "../../UI/Settings";
import SmmTicketProfile from "../../UI/SmmTicketProfile";

const SmmTicketProfilePage = () => {
    const [data, setData] = useState();
    const [campaings, setCampaings] = useState();
    const [currentPage, setCurrentPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(20);
    const getData = async () => {
        const { response } = await Helper.Get({
            url: `${api_Routes.Smmticket.View}?limit=${rowsPerPage}&page=${currentPage}`,
            hasToken: true,
        });
        if (response) {
            setData(response.message.result.profileData);
            setCampaings(response.message.result.campaigns);
        }
    };
    useEffect(() => {

        getData();
    }, []);
    return <SmmTicketProfile
        data={data}
        campaings={campaings}
        getData={getData}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
    />;
};

export default SmmTicketProfilePage;
